import { useEffect, useId, useSyncExternalStore } from "react";

// A module level store rather than a context, so it applies to every drawer in
// the app without one having to be mounted inside a provider.
const openPriorityDrawers = new Set<string>();
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function anyPriorityDrawerOpen() {
  return openPriorityDrawers.size > 0;
}

export function useDrawerPriority(open: boolean, priority: boolean): boolean {
  const id = useId();
  const blocked = useSyncExternalStore(
    subscribe,
    anyPriorityDrawerOpen,
    () => false,
  );

  useEffect(() => {
    if (!open || !priority) return;

    openPriorityDrawers.add(id);
    emit();

    return () => {
      openPriorityDrawers.delete(id);
      emit();
    };
  }, [open, priority, id]);

  return priority ? open : open && !blocked;
}
